import { Controller } from '@hotwired/stimulus';
import { useClickOutside } from 'stimulus-use';

export default class extends Controller {
  static targets = ['panel', 'outside', 'open'];
  static values = {
    initialHidden: Boolean
  };

  connect() {
    if (this.hasOutsideTarget) useClickOutside(this, { element: this.outsideTarget });
    if (this.hasPanelTarget) {
      this.panelTarget.hidden = this.initialHiddenValue;
    }
  }

  open() {
    this.panelTarget.hidden = false;
    const mainSection = document.querySelector('.staff-layout__main-section');
    mainSection &&
      mainSection.classList.add('staff-layout__main-section--with-side-panel');
  }

  clickOutside(event) {
    if (this.openTarget.contains(event.target)) {
      return;
    }
    this.close();
  }

  close() {
    this.panelTarget.hidden = true;
    const mainSection = document.querySelector('.staff-layout__main-section');
    mainSection &&
      mainSection.classList.remove('staff-layout__main-section--with-side-panel');
    window.dispatchEvent(new Event('resize'));
  }

  toggle() {
    this.panelTarget.style.display === 'block' ? this.close() : this.open();
    window.dispatchEvent(new Event('resize'));
  }
}
